import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateRefreshTable, updateShowTable } from "../../../redux/actions/actionsSlice";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function ActionsHeader() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const handleReloadPage = () => {
		dispatch(updateRefreshTable(true));
		setTimeout(() => {
			dispatch(updateRefreshTable(false));
		}, 1000);
	};

	return (
		<div className='generalStyles__spaceBetween'>
			<div className='generalStyles__mlFix mt-1'>
				<Button
					className='buttonStyle__9'
					onClick={() => {
						dispatch(updateShowTable(false));
					}}
				>
					{t("configuration.cancel")}
				</Button>
			</div>
			{validatePermission("data-blocks-catalog", permissions) && (
				<div className='generalStyles__mlFix mt-1'>
					<Button
						className='buttonStyle__10'
						icon={<FontAwesomeIcon icon={faArrowsRotate} />}
						onClick={() => {
							handleReloadPage();
						}}
					/>
				</div>
			)}
		</div>
	);
}

export default ActionsHeader;
